import { WhatsappLogo } from '@phosphor-icons/react';
import { COMPANY_INFO } from '@/lib/constants';

export const WhatsAppButton = () => {
  const whatsappNumber = COMPANY_INFO.whatsapp.replace(/[\s+-]/g, '');
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=Hello! I'm interested in your travel services.`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-btn"
      className="fixed bottom-6 right-6 z-50 bg-[#25D366] text-white p-4 rounded-full shadow-lg hover:scale-110 transition-transform whatsapp-pulse"
      aria-label="Chat on WhatsApp"
    >
      <WhatsappLogo size={32} weight="fill" />
    </a>
  );
};
